import React from 'react';
import AppRoutes from './routes/routes';

const App: React.FC = () => <AppRoutes />;

export default App;
